import {inject, RESPONSE_INIT} from '@angular/core';
import {CanActivateChildFn, Router} from '@angular/router';
import {UserService} from '@services/user/user.service';
import {guardRedirect} from './guard-redirect';

/**
 * Guard to check if the user's organization has a data_enclave_url configured.
 * Redirects to the guest page if the organization does not have a data enclave URL.
 * For server-side rendering, sets the response status to 403 Access Denied.
 */
export const privateDataEnclaveOrgGuard: CanActivateChildFn = async (childRoute, _state) => {
  const router = inject(Router);
  const response = inject(RESPONSE_INIT, {optional: true});
  const userService = inject(UserService);

  const user = await userService.userPromise;

  if (user?.organization?.data_enclave_url) return true;

  return guardRedirect('/pde-guest', router, response);
};
